// var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
//   "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"
// ];

// function dateFormatter(date) {
//  var m = monthNames[date.getMonth()];
//   // return date.getMonth() + date.getDate();
//   return m + ' ' + date.getDate() + ', ' + date.getFullYear();
// }

var configProfile = {
	"profile": {"screenName": 'BlueprintMeds'},
	"domId": 'twitter-content',
	"maxTweets": 1,
	"enableLinks": true, 
	"showUser": true,
	"showTime": false,
	"showImages": true,
	"showInteractionLinks": false,
	"lang": 'en'
};

if (jQuery('#twitter-content').length > 0) {
	twitterFetcher.fetch(configProfile);
}

document.addEventListener( "DOMContentLoaded", function() {
	var tweet = document.getElementById('twitter-content');
	if(tweet) {
		var tweetNotLoaded = tweet.innerHTML === "";
		if (tweetNotLoaded) {
			tweet.innerHTML = '<p>The tweet could not be loaded. It could have been blocked by your browser\'s settings.</p>';
		}
	}
});

// 	setTimeout(function(){

// 		var showChar = 120;
// 		var showChar_mobile = 80;

// 		var twitter_parent_link_element = jQuery("#twitter-content").parent();
// 		var tweek_link = jQuery("#twitter-content .timePosted a").attr('href');
// 		var tweek_link_h3_text = jQuery("#twitter-content .timePosted a").text();

// 		if ( (window.matchMedia("(min-width: 1024px)").matches) ) {
// 	        var tweek_link_h4_text = jQuery("#twitter-content .tweet").text().substr(0, showChar);
// 	    } else {
// 	    	var tweek_link_h4_text = jQuery("#twitter-content .tweet").text();
// 	    }

// 		jQuery("#twitter-content .timePosted").text(tweek_link_h3_text);
// 		jQuery("#twitter-content .tweet").text(tweek_link_h4_text + ' ...');

// 		twitter_parent_link_element.attr('href',tweek_link);



// 	},500);

// }

// twitterFetcher.fetch(configProfile);